var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createHash } from 'crypto';
import { MAX_STRING_LENGTH } from '../Constants';
import { TeamCTI } from '../TeamCTI';
/**
 * generateErrorCode
 * Uses unique identifiers to generate a 8 character length error code.
 * @param {IErrorCodeContextInputs} errorCodeContextInputs - Props to generate error code.
 * @returns {string || undefined} - 8 character length code or undefined on error
 */
export const generateErrorCode = (errorCodeContextInputs) => {
    try {
        if (!propsValid(errorCodeContextInputs)) {
            return undefined;
        }
        const data = createErrorCodeHashKey(errorCodeContextInputs);
        const hashRes = createHash('sha256').update(data).digest('hex');
        const errorCodeRes = hashRes.slice(0, 8);
        return errorCodeRes;
    }
    catch (err) {
        console.warn('Error encoding data when generateErrorCode: ', err);
        return undefined;
    }
};
/**
 * Fallback function to convert error code to displayable error code string
 * Should only be used in case intl is missing or failing as this doesn't provide localization
 * @param {string} errorCode - raw error code
 * @returns {string} - displayable error code in English
 */
export const generateErrorCodeDefaultDisplay = (errorCode) => {
    return `[Error code: ${errorCode}]`;
};
/**
 * DEPRECATED function. Do not use.
 * TODO: https://sim.amazon.com/issues/caracara-40125 - Remove after all clients migrate to generateErrorCode
 * */
//
export const getErrorCode = (errorStringId, errorSourceId) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        const errorCode = generateErrorCode({
            uniqueKey: errorStringId,
            sourceId: errorSourceId,
            cti: TeamCTI.Sapphire.sessionControlBar,
        });
        resolve(errorCode);
    });
});
export const propsValid = (errorCodeContextInputs) => {
    if (!errorCodeContextInputs) {
        return false;
    }
    if (errorCodeContextInputs.sourceId === undefined ||
        errorCodeContextInputs.sourceId === null) {
        return false;
    }
    // [caracara-32767] Add CTI prop validation once we can require CTI.
    // [caracara-32742] Add uniqueKey prop validation once we can require uniqueKey.
    return true;
};
export const createErrorCodeHashKey = (errorCodeContextInputs) => {
    var _a;
    const { sourceId, cti, uniqueKey } = errorCodeContextInputs;
    const shortenedKey = (_a = uniqueKey === null || uniqueKey === void 0 ? void 0 : uniqueKey.slice(0, MAX_STRING_LENGTH)) !== null && _a !== void 0 ? _a : '';
    const ctiString = cti ? `${cti.category}/${cti.type}/${cti.item}` : '';
    const errorCodeHashKey = `${sourceId}${ctiString}${shortenedKey}`;
    return errorCodeHashKey;
};
//# sourceMappingURL=ErrorUtils.js.map